import { Injectable }   from "@angular/core";
import { Observable } from "rxjs";
import { Subject }      from "rxjs/Subject";

@Injectable()
export class GlobalState {
    private _data = new Subject<Object>();
    private _dataStream$ = this._data.asObservable();

    private _subscriptions: Map<string, Array<Function>> = new Map<string, Array<Function>>();

    constructor() {
        this._dataStream$.subscribe((data) => this._onEvent(data));
    }

    public notifyDataChanged(event, value) {
        let current = this._data[event];
        if (current !== value) {
            this._data[event] = value;

            this._data.next({
                event: event,
                data: this._data[event]
            });
        }
    }
    public subscribe(event: string, callback: Function) {
        let subscribers = this._subscriptions.get(event) || [];
        subscribers.push(callback);

        this._subscriptions.set(event, subscribers);
    }
    public unSubscribe(event: string) {
        this._subscriptions.delete(event);
    }

    private _onEvent(data: any) {
        let subscribers = this._subscriptions.get(data["event"]) || [];
        
        subscribers.forEach((callback) => {
            callback.call(null, data["data"]);
        });
    }

    private focusProcessing: boolean = false;
    public setFocus(event) {
        if (this.focusProcessing == true) {
            return;
        }
        this.focusProcessing = true;
        setTimeout(() => {
            event();
            this.focusProcessing = false;
        }, 0);
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/services/global.state.ts